export const seguimientoSort = () => [
  { property: 'fecha_vencimiento', direction: 'ASC' },
  { property: 'id', direction: 'ASC' },
];
export function closingProbability(record = {}) {
  const probability = record.oportunidad?.probabilidad || record.probabilidad;
  return probability?.id ? { value: probability.id, label: probability.descripcion } : null;
}
